import { jsx as _jsx } from "react/jsx-runtime";
var NewArrowDown = function NewArrowDown(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181b32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9999 5L10.9999 16.865L6.63991 13.232C6.21591 12.878 5.58491 12.936 5.23191 13.36C4.87791 13.785 4.93591 14.415 5.35991 14.768L11.3599 19.768C11.4069 19.807 11.4619 19.827 11.5139 19.856C11.5559 19.88 11.5919 19.909 11.6379 19.927C11.7529 19.972 11.8739 19.999 11.9959 19.999C11.9969 19.999 11.9989 20 11.9999 20C12.0009 20 12.0029 19.999 12.0039 19.999C12.1259 19.999 12.2469 19.972 12.3619 19.927C12.4079 19.909 12.4439 19.88 12.4859 19.856C12.5379 19.827 12.5929 19.807 12.6399 19.768L18.6399 14.768C18.8769 14.57 18.9999 14.286 18.9999 14C18.9999 13.774 18.9239 13.547 18.7679 13.36C18.4149 12.936 17.7839 12.878 17.3599 13.232L12.9999 16.865L12.9999 5C12.9999 4.448 12.5519 4 11.9999 4C11.4479 4 10.9999 4.448 10.9999 5Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default NewArrowDown;